export default {
    when() {
        return document.querySelectorAll('.nav').length > 0;
    },

    mounted() {
        document.querySelectorAll('.nav').forEach((element) => {
            $('.burger').on('click', function() {
                $('nav').toggleClass('nav--open');
                $('body').toggleClass('overflow-hidden');
            });

            // let test = $('nav .menu-primary-navigation-container li:not(.sub-menu li)');
            // console.log(test);

            // test.bind('click', function() {
            //     $(this).toggleClass('open');
            // });

            $('nav .search').on('click', function(e) {
                document.getElementById('modal-input').focus();
                e.preventDefault();
                $('body').addClass('search--open');

                $('.modal-search').on('click', function(event) {
                    if (!$(event.target).closest('#form').length) {
                        $('body').removeClass('search--open');
                    }
                });

                $(document).keyup(function(e) {
                    if (e.key === 'Escape') {
                        // escape key maps to keycode `27`
                        $('body').removeClass('search--open');
                    }
                });
            });
        });
    },
};
